import api from '../../../services/api';
import {
  setOrderDetail,
  setLoading,
  setError,
  updateOrderStatus as updateStatus
} from '../reducers';

// Fetch order detail
export const fetchOrderDetail = (id) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.get(`/orders/${id}`);
    dispatch(setOrderDetail(response.data));
    return response.data;
  } catch (error) {
    console.error('Error fetching order detail:', error);
    dispatch(setError('Không thể tải thông tin đơn hàng'));
    return null;
  } finally {
    dispatch(setLoading(false));
  }
};

// Update order status
export const updateOrderStatus = ({ id, status }) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.put(`/orders/${id}`, { orderStatus: status });
    dispatch(updateStatus(status));
    dispatch(setOrderDetail(response.data));
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error updating order status:', error);
    dispatch(setError('Không thể cập nhật trạng thái đơn hàng'));
    return { success: false, error: error.message };
  } finally {
    dispatch(setLoading(false));
  }
};

// Navigation actions
export const navigateToOrders = (navigate) => () => {
  navigate('/orders');
};

export const navigateToEditOrder = (id, navigate) => () => {
  navigate(`/orders/${id}/edit`);
};

export const printOrder = () => () => {
  window.print();
}; 